import React from 'react';
import { Box } from '@mui/material';

export default function PoolItem({
  pool,
  onViewPool
}: {
  pool: { id: number; title: string };
  onViewPool?: (poolId: number) => void;
}) {
  return (
    <Box
      style={{
        padding: '5px 10px',
        cursor: 'pointer',
        borderRadius: '26px',
        zIndex: 1,
        marginLeft: '-10px',
        border: '10px solid #FFFFFF',
        backgroundColor: '#F5F5F5'
      }}
      onClick={() => onViewPool && onViewPool(pool.id)}
    >
      {pool.title}
    </Box>
  );
}
